import { CommunityMembersSearchDocument, CommunityMembersSearchQuery, Membership } from '~/api/generated/graphql'
import { MemberQueryVariables } from '~/types'
import { sortMemberships } from '~/common/utils'

export const getMemberSearchReadParams = (memberQueryVariables: MemberQueryVariables) => {
  return {
    query: CommunityMembersSearchDocument,
    variables: memberQueryVariables,
  }
}

export const getMemberSearchWriteParams = (
  newMembership: Membership,
  existingData: CommunityMembersSearchQuery,
  memberQueryVariables: MemberQueryVariables
) => getBulkMemberSearchWriteParams([newMembership], existingData, memberQueryVariables)

export const getBulkMemberSearchWriteParams = (
  newMemberships: Membership[],
  existingData: CommunityMembersSearchQuery,
  memberQueryVariables: MemberQueryVariables
) => {
  return {
    query: CommunityMembersSearchDocument,
    variables: memberQueryVariables,
    data: {
      communityMembers: {
        ...existingData.communityMembers,
        pageInfo: existingData.communityMembers!.pageInfo,
        count: (existingData.communityMembers!.count ?? 0) + 1,
        members: sortMemberships(
          [...(existingData.communityMembers!.members as Membership[]), ...newMemberships],
          memberQueryVariables.sortType,
          memberQueryVariables.sortDirection
        ),
      },
    },
  }
}
